import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Projects.css';
import {
    FaTasks, FaClock, FaUsers, FaShieldAlt,
    FaDatabase, FaBook, FaCode
} from 'react-icons/fa';
import { SiDotnet } from 'react-icons/si';

const Projects = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const projects = [
        {
            id: 1,
            icon: <FaBook />,
            title: "Course Management System",
            description: "Developed comprehensive course management system as ITI graduation project implementing Three-Tier Architecture and Repository Pattern.",
            technologies: [
                { name: "ASP.NET Core", icon: <SiDotnet /> },
                { name: "EF Core", icon: <FaDatabase /> },
                { name: "SQL Server", icon: <FaDatabase /> },
                { name: "C#", icon: <FaCode /> }
            ],
            features: [
                {
                    icon: <FaDatabase />,
                    title: "CRUD Operations",
                    description: "Built full CRUD operations with advanced validation including Data Annotations and Remote Validation"
                },
                {
                    icon: <FaShieldAlt />,
                    title: "Architecture",
                    description: "Implemented Three-Tier Architecture, Repository Pattern, and clean code principles"
                },
                {
                    icon: <FaUsers />,
                    title: "User Management",
                    description: "Implemented pagination, search functionality, and role-based user management"
                }
            ]
        },
        {
            id: 2,
            icon: <FaTasks />,
            title: "Task Management System",
            description: "Developed task management web application with user authentication and authorization system.",
            technologies: [
                { name: "ASP.NET Core", icon: <SiDotnet /> },
                { name: "EF Core", icon: <FaDatabase /> },
                { name: "SQL Server", icon: <FaDatabase /> },
                { name: "C#", icon: <FaCode /> }
            ],
            features: [
                {
                    icon: <FaShieldAlt />,
                    title: "Secure Access",
                    description: "Implemented secure role-based access control and user management functionality"
                },
                {
                    icon: <FaClock />,
                    title: "Task Tracking",
                    description: "Built task assignment, tracking, deadline management, and time logging features"
                },
                {
                    icon: <FaDatabase />,
                    title: "Database Design",
                    description: "Designed database architecture using Entity Framework Core with SQL Server backend"
                }
            ]
        }
    ];

    return (
        <section className="projects" id="projects">
            <div className="projects-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container projects-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        Featured <span className="gradient-text">Projects</span>
                    </h2>
                    <p className="section-subtitle">
                        Showcasing my technical expertise through real-world applications
                    </p>
                </div>

                <div className="projects-list">
                    {projects.map((project, index) => (
                        <div
                            className="project-card"
                            key={project.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="project-header">
                                <div className="project-icon">{project.icon}</div>
                                <div className="project-title-section">
                                    <h3 className="project-title">{project.title}</h3>
                                    <p className="project-description">{project.description}</p>
                                </div>
                            </div>

                            <div className="project-technologies">
                                <h4 className="tech-title">Technologies Used</h4>
                                <div className="tech-stack">
                                    {project.technologies.map((tech, idx) => (
                                        <div className="tech-item" key={idx}>
                                            <span className="tech-icon">{tech.icon}</span>
                                            <span className="tech-name">{tech.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="project-features">
                                <h4 className="features-title">Key Features</h4>
                                <div className="features-grid">
                                    {project.features.map((feature, idx) => (
                                        <div className="feature-item" key={idx}>
                                            <div className="feature-icon">{feature.icon}</div>
                                            <div className="feature-content">
                                                <h5 className="feature-title">{feature.title}</h5>
                                                <p className="feature-description">{feature.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Projects;
